/**
 * Created with JetBrains WebStorm.
 * User: sebastienbeaujard
 * Date: 29/07/13
 * Time: 17:10
 * To change this template use File | Settings | File Templates.
 */
angular.module('FlexyBeautyApp.services').factory('CheckDeposit_Resource', ["$resource", "$location", function ($resource, $location) {
    var baseUrl = $location.protocol() + "://" + $location.host() + ($location.port() && ":" + $location.port()) + "/";
    var resourceCheckDeposits = $resource(baseUrl + 'rest/checkDeposits/:id', {}, {
        query: {method: 'GET', isArray: true},
        get: {method: 'GET'}
    });
    return resourceCheckDeposits;
}
]);

angular.module('FlexyBeautyApp.services').factory('CheckDeposit', ["CheckDeposit_Resource", "ProductCategoryData", "ProductData", "CheckDepositData", "HumanResourceData",
    function (CheckDeposit_Resource, ProductCategoryData, ProductData, CheckDepositData, HumanResourceData) {
        //CheckDeposit inherit from Activity
        var CheckDeposit = function (checkDepositRes, isPreviousVersion) {
            this.id = null;
            this.cdNumber = null;
            this.bankDate = null;
            this.status = null;
            this.description = null;
            this.humanResource = null;
            this.timeCreated = new Date();
            this.salePayments = [];
            this.version = null;
            this.loadObject(checkDepositRes);
            if (isPreviousVersion == undefined || !isPreviousVersion)//A previous version is not added to DATA
                CheckDepositData.add(this);
        }

        CheckDeposit.prototype.loadObject = function (object) {

            if (object !== undefined && object != null) {
                if (!this.id)
                    this.id = object.id;
                this.status = object.status;
                if (object.bankDate)
                    this.bankDate = new Date(object.bankDate);
                this.cdNumber = object.cdNumber;
                this.description = object.description;
                if (object.timeCreated)
                    this.timeCreated = new Date(object.timeCreated);
                if (object.humanResourceId)
                    this.humanResource = HumanResourceData.getById(object.humanResourceId);
                if (object.version)
                    this.version = object.version;
            }
        };
        CheckDeposit.prototype.copyDataTo = function (object) {

            object.id = this.id;
            object.status = this.status;
            object.cdNumber = this.cdNumber;
            object.description = this.description;
            object.bankDate = this.bankDate;

            if (this.humanResource)
                object.humanResourceId = this.humanResource.id;


        };
        CheckDeposit.prototype.addSalePayment = function (sale, payment) {
            this.salePayments.push({sale: sale, payment: payment});
        };


        CheckDeposit.prototype.getObjectResource = function () {
            var checkDepositRes = new CheckDeposit_Resource();
            this.copyDataTo(checkDepositRes);
            return checkDepositRes;
        };
        CheckDeposit.prototype.setIdUsingObject = function (object) {
            this.id = object.id;
        };
        CheckDeposit.prototype.setId = function (id) {
            this.id = id;
        };
        CheckDeposit.prototype.getId = function () {
            return this.id;
        };
        CheckDeposit.prototype.getLabel = function () {
            return this.label;
        };

        return CheckDeposit;
    }
]);

angular.module('FlexyBeautyApp.services').factory('CheckDepositSrv', ["$log", "ServerSrv", "CheckDepositData", "CheckDeposit", "CheckDeposit_Resource",
    function ($log, ServerSrv, CheckDepositData, CheckDeposit, CheckDeposit_Resource) {
        var bpSrv = {};

        bpSrv.query = function (successFunction, errorFunction) {
            CheckDeposit_Resource.query(
                {}, //params
                function (data) {   //success
                    CheckDepositData.clear();
                    for (var i = 0; i < data.length; i++)
                        new CheckDeposit(data[i], false);//Auto Add to CheckDepositData
                    if (successFunction !== undefined)
                        successFunction(CheckDepositData.getActiveList());

                },
                function (data) {   //failure
                    $log.error("CheckDeposit_Resource.query error");
                    $log.error(data);
                    if (errorFunction !== undefined)
                        errorFunction(data);
                });
        };
        bpSrv.save = function (checkDeposit, salePaymentsToRemove, salePaymentsToAdd, successFunction, errorFunction) {
            ServerSrv.startSavingProcess(bpSrv.saveSync, checkDeposit, salePaymentsToRemove, salePaymentsToAdd, successFunction, errorFunction);
        };
        bpSrv.saveSync = function (checkDeposit, salePaymentsToRemove, salePaymentsToAdd, successFunction, errorFunction) {
            var bsRes = checkDeposit.getObjectResource();
            bsRes.salePaymentsToRemove = salePaymentsToRemove;
            bsRes.salePaymentsToAdd = salePaymentsToAdd;
            bsRes.$save({}, //no params
                function (upRes) {
                    try {
                        // now we can set the id
                        checkDeposit.setId(upRes.id);
                        if (!checkDeposit.version || (upRes.version && upRes.version > checkDeposit.version))
                            checkDeposit.version = upRes.version;
                        if (upRes.timeCreated)
                            checkDeposit.timeCreated = new Date(upRes.timeCreated);

                        if (upRes.cdNumber)
                            checkDeposit.cdNumber = upRes.cdNumber;
                        //Add user action
                        //UserActionSrv.add(data.userAction);
                        //CallBack on success
                        if (successFunction != undefined)
                            successFunction(upRes);
                    } finally {
                        ServerSrv.endSavingProcess(true);
                    }
                },
                function (data) {   //failure
                    //error handling goes here
                    try {
                        if (errorFunction != undefined)
                            errorFunction(data);
                    } finally {
                        ServerSrv.endSavingProcess(false, (data ? data.status : null), (data && data.data ? data.data.errorCode : null));
                    }
                }
            );
        };
        bpSrv.updateLocally = function (id, resource) {
            var checkDeposit = CheckDepositData.getById(id);

            if (checkDeposit && checkDeposit.version && resource.version && resource.version < checkDeposit.version)
                return null;

            if (checkDeposit != null)
                checkDeposit.loadObject(resource);

            return checkDeposit;

        };
        bpSrv.removeLocally = function (id, resource) {
            return CheckDepositData.getById(id);
        };
        bpSrv.addLocally = function (id, resource) {
            var checkDeposit = CheckDepositData.getById(id)
            if (checkDeposit != null) //check if resource already exist inside index (current action could be a 'cancel')
                checkDeposit.loadObject(resource);
            else {
                checkDeposit = new CheckDeposit(resource);
                checkDeposit.id = id;
            }
            return checkDeposit;
        };
        bpSrv.getPreviousVersionInstance = function (resource) {
            var checkDeposit = new CheckDeposit(resource, true);
            return checkDeposit;

        };

        return bpSrv;
    }
]);

angular.module('FlexyBeautyApp.services').factory('CheckDepositData', ["$log", function ($log) {
    var checkDepositData = {
        indexCheckDeposits: []
    };

    checkDepositData.getById = function (checkDepositId) {
        for (var i = 0; i < this.indexCheckDeposits.length; i++)
            if (this.indexCheckDeposits[i].id == checkDepositId)
                return this.indexCheckDeposits[i];
        return null;
    }

    checkDepositData.getIndexOf = function (checkDeposit) {
        if (checkDeposit)
            return this.indexCheckDeposits.indexOf(checkDeposit);
        return -1;
    }

    checkDepositData.getByIndex = function (index) {
        if (index >= 0 && index < this.indexCheckDeposits.length)
            return this.indexCheckDeposits[index];
        else
            return null;
    }

    checkDepositData.add = function (checkDeposit) {
        this.indexCheckDeposits.push(checkDeposit);
        return this.indexCheckDeposits.length - 1;
    }

    checkDepositData.clear = function () {
        checkDepositData.indexCheckDeposits = [];
    }

    checkDepositData.getActiveList = function () {
        return this.indexCheckDeposits;
    }

    checkDepositData.clearSalePayments = function () {
        this.indexCheckDeposits.forEach(checkDeposit => checkDeposit.salePayments = []);
    }

    return checkDepositData;
}]);



// WEBPACK FOOTER //
// ./js/services/models/CheckDeposit.js